import { Megaphone } from "lucide-react"
import { useLocation } from "react-router"

import { ArrowIcon } from "~/components/ui/button"

const POST_HREF = "/blog/welcome-to-pine59"

// Pine59 announcement bar: a thin lime strip above the sticky nav that scrolls
// away with the page. Megaphone, the one-line buyout message, then a
// "Read more here →" link. Text wraps on narrow screens; nothing is hidden.
// On the launch post itself the link is dropped — it would just point back to
// the current page. The server answers trailing-slash URLs too, so compare
// without one.
export function AnnouncementBanner() {
  const onPost = useLocation().pathname.replace(/\/+$/, "") === POST_HREF

  return (
    <div className="bg-lime text-forest">
      <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1 px-5 py-2.5 text-center sm:px-8">
        <Megaphone
          className="hidden h-4 w-4 shrink-0 sm:block"
          strokeWidth={2}
          aria-hidden
        />
        <p className="text-[14px] font-medium leading-snug">
          Unacast&rsquo;s Aggregated Location Insights business is now Pine59
        </p>
        {!onPost && (
          <a
            href={POST_HREF}
            className="inline-flex shrink-0 items-center gap-1 text-[14px] font-semibold underline decoration-forest/40 underline-offset-2 transition-colors hover:decoration-forest"
          >
            Read more here
            <ArrowIcon />
          </a>
        )}
      </div>
    </div>
  )
}
